<div
  class="white-bg"
  [ngClass]="{
    'rounded-large border': hasBorder && roundedBottom,
    'rounded-top-large border-top border-left border-right': hasBorder && !roundedBottom,
    'pr-small-t': fullWidth,
    'pr-small': !fullWidth,
  }"
>
  <h2
    class="font-heading-4 flex flex--center flex--space-between"
    [class.nordic-blue-900-text]="!showHighlightedContent"
    [class.heather-700-text]="showHighlightedContent"
    [class.pr-small-x]="fullWidth"
    [class.pr-small-b]="shouldShowSmallPadding"
    *ngIf="title || endTitle"
  >
    <span class="block">{{ title }}</span>
    <span class="block {{ endTitleClasses }}">{{ endTitle }}</span>
  </h2>
  <div class="flex section-list" *ngIf="!noContent">
    <ng-content select="content" />
  </div>
  <div class="align-right font-body-1" *ngIf="!noButton">
    <ng-content select="button" />
  </div>
</div>
